<section class="card">
    <div class="card-body">
        <form class="cat__app__profile__container py-0" #contactForm="ngForm">
            <div class="row">
                <div class="col-12 mb-3">
                    <h5 class="text-black"><strong>Emergency contacts</strong></h5>
                </div>
                <div class="col-12 new-item" *ngIf="model.emergencyContacts.length === 0">
                    <div class="form-group row pt-10">
                        No emergency contacts. Please add one, using the "Add Emergency Contact" button above.
                    </div>
                </div>
                <div class="col-12" *ngIf="model.emergencyContacts.length > 0">
                    <table class="table-edit">
                        <thead class="table-head">
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Contact for</th>
                            <th>Relationship</th>
                            <th class="profile-last-col">Actions</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let contact of model.emergencyContacts">
                                <td class="profile-row">
                                    {{ contact.firstName + ' ' + contact.lastName }}
                                </td>
                                <td>{{ contact.emergencyContactPhones[0].phoneNumber }}</td>
                                <td>{{ contact.emergencyContactType.name }}</td>
                                <td>{{ contact.constituentRelationshipType.description }}</td>
                                <td class="actions">
                                    <i (click)="edit(contact)" class="fa fa-pencil edit-btn"></i>
                                    <i (click)="delete(contact)" class="fa fa-trash-o"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-12 mt-2">
                            <div *ngIf="!isFormVisible" class="my-3">
                                <a class="profile-add-more"
                                        (click)="create()"
                                        id="profile-Add-Btn">
                                    Add Emergency Contact
                                </a>
                            </div>
                            <form #form="ngForm" *ngIf="isFormVisible" class="row mt-3 d-flex align-items-center">
                                <div class="col-12 col-lg-6 col-xl-3 mb-2 mb-lg-0 mt-sm-3">
                                    <div class="d-flex flex-column mb-2 mb-md-0">
                                        <label class="form-control-label">First Name</label>
                                        <input type="text"
                                                name="contact-first-name"
                                                [(ngModel)]="editModel.firstName"
                                                required
                                                #firstName="ngModel"
                                                [disabled]="eventService?.selectedEvent?.isPastEvent"
                                                class="form-control">
                                        <div class="form-control-error"
                                                *ngIf="!firstName.valid && (firstName.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="firstName?.errors?.required">First Name is required.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-6 col-xl-3 mt-sm-3">
                                    <div class="d-flex flex-column">
                                        <label class="form-control-label">Last Name</label>
                                        <input type="text"
                                                name="contact-last-name"
                                                [(ngModel)]="editModel.lastName"
                                                required
                                                #lastName="ngModel"
                                                [disabled]="eventService?.selectedEvent?.isPastEvent"
                                                class="form-control">
                                        <div class="form-control-error"
                                                *ngIf="!lastName.valid && (lastName.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="lastName?.errors?.required">Last Name is required.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-4 pb-3 pb-sm-0 mt-sm-3">
                                    <div class="d-flex flex-column">
                                        <label class="form-control-label">Phone</label>
                                        <input type="text"
                                                name="contact-phone"
                                                [(ngModel)]="editModel.emergencyContactPhones[0].phoneNumber"
                                                placeholder="(888) 910-1101"
                                                [dropSpecialCharacters]="false"
                                                mask="(000) 000-0000"
                                                pattern="^([\(]{1}[0-9]{3}[\)]{1}[ |\-]{0,1}|^[0-9]{3}[\-| ])?[0-9]{3}(\-| ){1}[0-9]{4}$"
                                                required
                                                #phone="ngModel"
                                                [disabled]="eventService?.selectedEvent?.isPastEvent"
                                                class="form-control">
                                        <div class="form-control-error"
                                                *ngIf="!phone.valid && (phone.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="phone?.errors?.required">Phone number is required.</li>
                                                <li *ngIf="phone?.errors?.pattern">Invalid format.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-4 pb-3 pb-sm-0 mt-sm-3">
                                    <div class="d-flex flex-column">
                                        <label class="form-control-label">Phone Type</label>
                                        <select class="form-control"
                                                name="contact-phone-type"
                                                required
                                                #phoneType="ngModel"
                                                [disabled]="eventService?.selectedEvent?.isPastEvent"
                                                [(ngModel)]="editModel.emergencyContactPhones[0].phoneType.constituentPhoneTypeID">
                                            <option class="form-check" *ngFor="let option of dictData.PhoneType" [ngValue]="option.cmgmtPhoneTypeId">
                                                {{ option.description }}
                                            </option>
                                        </select>
                                        <div class="form-control-error"
                                                *ngIf="!phoneType.valid && (phoneType.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="phoneType?.errors?.required">Phone type is required.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mt-sm-3">
                                    <div class="d-flex flex-column">
                                        <label class="form-control-label">Contact for</label>
                                        <select class="form-control"
                                                name="contact-contact-for"
                                                required
                                                #contactFor="ngModel"
                                                [disabled]="eventService?.selectedEvent?.isPastEvent"
                                                [(ngModel)]="editModel.emergencyContactType.emergencyContactTypeId">
                                            <option class="form-check" *ngFor="let option of dictData.EmergencyContactType" [ngValue]="option.emergencyContactTypeId">
                                                {{ option.name }}
                                            </option>
                                        </select>
                                        <div class="form-control-error"
                                                *ngIf="!contactFor.valid && (contactFor.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="contactFor?.errors?.required">Contact for is required.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4 mt-sm-3">
                                    <div class="d-flex flex-column">
                                        <label class="form-control-label">Relationship</label>
                                        <select class="form-control"
                                                name="contact-relationship"
                                                required
                                                #relationship="ngModel"
                                                [disabled]="eventService?.selectedEvent?.isPastEvent"
                                                [(ngModel)]="editModel.constituentRelationshipType.constituentRelationshipTypeId">
                                            <option class="form-check" *ngFor="let option of dictData.ConstituentRelationshipType" [ngValue]="option.constituentRelationshipTypeId">
                                                {{ option.description }}
                                            </option>
                                        </select>
                                        <div class="form-control-error"
                                                *ngIf="!relationship.valid && (relationship.touched || state.isSubmitted)">
                                            <ul>
                                                <li *ngIf="relationship?.errors?.required">Relationship is required.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-3 mb-3">
                                    <button type="button"
                                            class="btn btn-primary mr-3"
                                            (click)="save()">Save</button>
                                    <button type="button"
                                            class="btn btn-outline-primary"
                                            (click)="cancel()">Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <p class="text-black">
                        Emergency Information is required in the case that you get hurt while training or participating
                        at the event. We recommend including family members and your physician's information.
                        Thanks, and have a safe event.
                    </p>
                </div>
            </div>
        </form>
    </div>
</section>
